import "./App.css";
import "./App.css";
import SalesByZone from "./Pages/SalesByZone/SalesByZone";
 
import SalesTrend from "./Pages/SalesTrend/SalesTrend";
 
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { SalesProvider } from "./Pages/SalesContext";
import BrandWiseSales from "./Pages/BrandWiseSales/BrandWiseSales";
import NewBrandSales from "./Pages/NewBrandSales/NewBrandSales";
import StockistDashboard from "./components/Stockist/StockistDashboard.tsx";
import LeadershipDashboardSLM from "./components/LeadershipDashboardSLM/LeadershipDashboardSlm.tsx";
import LeadershipDashboardMR from "./components/LeadershipDashboardsMR/LeadershipDashboardMr.tsx";
import LeadershipDashboardFLM from "./components/LeadershipDashboardsFLM/LeadershipDashboardflm.tsx";
import Breakage_Dashboard from "./components/BreakageDashboard/BreakageDashboard";
import CustomerCoverage from './CustomerCoverage/coverageDashboard.tsx';
import CustomerVisit from './CustomerVisitTracker/CustomerVisitDashboard.tsx';
import MyPerformance from "./Pages/MyPerformance/MyPerformance.tsx"
import WorkhabitKpi from "./Pages/WorkhabitKpi/WorkHabitKpi"
import ErrorBoundary from "./utils/ErrorBoundary.jsx";
import DashboardDataComponent from "./components/NewDashboard/DashboardDataComp.tsx"; // Adjust the path as needed

function NotFoundPage() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
<ErrorBoundary>
     <Routes>
          {/* Wrap only the specific components that need SalesProvider */}
        <Route path="/app/salestrend_dashboard" element={
  <SalesProvider>
    <SalesTrend />
  </SalesProvider>
} />

          <Route
            path="/app/salesbyzone_dashboard"
            element={
              <SalesProvider>
                <SalesByZone />
              </SalesProvider>
            }
          />
             <Route
            path="/app/brandwisesales_dashboard"
            element={
              <SalesProvider>
                <BrandWiseSales />
              </SalesProvider>
            }
                      />
                       <Route
            path="/app/newbrandsales_dashboard"
            element={
              <SalesProvider>
                <NewBrandSales />
              </SalesProvider>
            }
                      />
                        <Route
            path="/app/breakage_dashboard/*"
         element={
          <SalesProvider >
            <Breakage_Dashboard />
          </SalesProvider>
         }
          />
             <Route
            path="/app/stockist_dashboard"
            element={
              <SalesProvider>
                <StockistDashboard />
              </SalesProvider>
            }
          />
              <Route
            path="/app/kpi_leadership_dashboard_MR"
            element={
              <SalesProvider>
                <LeadershipDashboardMR />
              </SalesProvider>
            }
          />
             <Route
            path="/app/kpi_leadership_dashboard_FLM"
            element={
              <SalesProvider>
                <LeadershipDashboardFLM />
              </SalesProvider>
            }
          />
             <Route
            path="/app/kpi_leadership_dashboard_SLM"
            element={
              <SalesProvider>
                <LeadershipDashboardSLM />
              </SalesProvider>
            }
          />
           <Route
            path="/app/my_performance"
            element={
              <SalesProvider>
                <MyPerformance />
              </SalesProvider>
            }
          />
           <Route
            path="/app/customercoverage_dashboard"
            element={
              <SalesProvider>
                <CustomerCoverage />
              </SalesProvider>
            }
          />
               <Route
            path="/app/customervisit_dashboard"
            element={
              <SalesProvider>
                <CustomerVisit />
              </SalesProvider>
            }
          />
            <Route
            path="/app/kpi_leadership_dashboard"
            element={
              <SalesProvider>
                <WorkhabitKpi />
              </SalesProvider>
            }
          />
       <Route
            path="/app/newdashboard"
            element={
              <SalesProvider>
                <DashboardDataComponent />
              </SalesProvider>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
</ErrorBoundary>
     
      </div>
    </Router>
  );
}
 
 

export default App;
